<template>
  <div class="tw-flex tw-items-center">
    <div class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-white tw-ring-24 tw-ring-white/20"></div>
    <div class="tw-grow tw-h-0 tw-border-t tw-border tw-border-white tw-border-dashed"></div>
    <div class="tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-ring-8 tw-ring-white/20"></div>
  </div>
</template>
<script>
export default {

}
</script>